const routerPaths = {
  HOME: '/',
  LOGIN: '/login',
  ACTIVATE_LICENSE: '/activate-license',
  HYBRID_FLOW: '/hybrid-settings',
  BILLING_PROFILE: '/billing-profile',
  SETTINGS: '/settings',
  REQUEST_TRIAL: '/request-trial',
  ERROR: '/error',
};

export default routerPaths;
